import React, { FC } from 'react';
import { Grid, Typography } from '@mui/material';
import Label from '../../components/Label/Label';

export interface GridLabel {
  label: string;
  title: string;
  id?: string;
  isOptional?: boolean;
  xs?: number;
}

type Props = {
  labels: GridLabel[];
  labelSx?: any;
  titleSx?: any;
};

const GridLabels: FC<Props> = ({ labels, labelSx, titleSx }) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {labels?.map(({ label, title, id, isOptional, xs }) =>
        isOptional ? (
          ''
        ) : (
          <Grid item xs={xs ?? 6} key={id}>
            <Label labelSx={labelSx} titleSx={titleSx} label={label} title={title} />
          </Grid>
        )
      )}
    </>
  );
};

export default GridLabels;
